export const PROFILE_MAX_WIDTH_PER_PAGE_IN_PX = {
  ELIGIBILITY: '784px',
}

export enum CHANGE_EMAIL_ERROR_TYPE {
  INVALID = 'INVALID',
  GENERIC = 'GENERIC',
}

export const affirmativeResponses = ['Y', 'y', 'Yes', 'yes', 'True', 'true', true, 1]

// Help center article URLs
export const NUCLEAR_BADGE_HELP_CENTER_URL = 'https://blended-care.zendesk.com/hc/en-us/articles/4619922890387'
export const INTEGRATED_BENEFITS_PROGRAM_HELP_CENTER_URL =
  'https://coaching-lyrahealth.zendesk.com/hc/en-us/articles/47211667365395-Integrated-Benefit-Program'
